import { isUndefinedOrNull } from '../../TypeHelpers';
export default function* select(iterable, selector) {
    if (isUndefinedOrNull(selector)) {
        return iterable;
    }
    for (const input of iterable) {
        yield selector(input);
    }
}
